import { api } from './api';
import type {
  ProjectMfaSettingsResponse,
  ProjectMfaSettingsUpdate,
} from '../types/projectMfaSettings';

export const projectMfaSettingsApi = {
  get: (projectId: string) =>
    api.get<ProjectMfaSettingsResponse>(`/api/projects/${projectId}/settings/mfa`),

  update: (projectId: string, data: ProjectMfaSettingsUpdate) =>
    api.put<ProjectMfaSettingsResponse>(`/api/projects/${projectId}/settings/mfa`, data),
};
